import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 3.5, style: {
  fill: "var(--neutral-text-weak)",
  stroke: "var(--neutral-border)"
}, fillOpacity: 0.16 }), /* @__PURE__ */ React.createElement("path", { d: "M11.9268 5.21967C11.6339 4.92678 11.159 4.92678 10.8661 5.21967C10.859 5.22674 10.8524 5.23424 10.8462 5.2421L7.37385 9.66674L5.28033 7.57322C4.98744 7.28033 4.51256 7.28033 4.21967 7.57322C3.92678 7.86612 3.92678 8.34099 4.21967 8.63388L6.86612 11.2803C7.15901 11.5732 7.63388 11.5732 7.92678 11.2803C7.9333 11.2738 7.93946 11.2669 7.94522 11.2597L11.9374 6.26947C12.2196 5.97582 12.2161 5.50897 11.9268 5.21967Z", style: {
  fill: "var(--primary-text)"
} }));
const ForwardRef = forwardRef(SvgCheckboxChecked);
export { ForwardRef as ReactComponent };
